/** @jsxImportSource @emotion/react */
"use client";

import { forwardRef } from "react";

import type { ThemeType } from "../../../../../global/emotion";
import { Text } from "../../../_base/_core/Text/Text.emotion";
import { useFormField } from "./FormField.emotion";

export const FormDescription = forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>((props, ref) => {
  const { formDescriptionId } = useFormField();

  return (
    <Text
      ref={ref}
      type="detail"
      size="l"
      id={formDescriptionId}
      css={(theme: ThemeType) => ({
        color: theme.semanticColors.neutralsMedium,
      })}
      {...props}
    />
  );
});

FormDescription.displayName = "FormDescription";
